<template>
	<!-- Content -->
  <div class="container-xxl flex-grow-1 container-p-y">
    <h4 class="fw-bold py-3 mb-4">
        <span>Product Cost List</span>
    </h4>
    <div class="row g-4 mb-4">
      <div class="col-sm-12 col-xl-12">
				<div class="card">
					<div class="card-body">
            <div class="col-12">
              <div class="row">
                <div class="col-sm-2 mb-3">
                  <label class="form-label">Start Date</label>
                  <flat-pickr 
                    :config="calendarConfig" 
                    placeholder="Select a date" 
                    id="register_date"
                    name="register-date" 
                    class="form-control"
                    v-model="conditions.start_date" 
                  >
                  </flat-pickr>
                  <div class="error-msg" v-if="v$.conditions.start_date.$error"> 
                    {{ v$.conditions.start_date.$errors[0].$message }}
                  </div>
                </div>
                <div class="col-sm-2 mb-3">
                  <label class="form-label">End Date</label>
                  <flat-pickr 
                    :config="calendarConfig" 
                    placeholder="Select a date" 
                    id="register_date"
                    name="register-date" 
                    class="form-control"
                    v-model="conditions.end_date" 
                  >
                  </flat-pickr>
                  <div class="error-msg" v-if="error_date"> 
                    Wrong End Date Value !
                  </div>
                  <div class="error-msg" v-if="v$.conditions.end_date.$error"> 
                    {{ v$.conditions.end_date.$errors[0].$message }}
                  </div>
                </div>
                <div class="col-sm-3 mb-3">
                    <label class="form-label">Contract No</label>
                    <input type="text" 
                      class="form-control"
                      v-model="conditions.contract_code"
                    >
                </div>
                <div class="col-sm-3 mb-3">
                  <label class="form-label">Invoice No</label>
                  <input type="text" 
                    class="form-control"
                    v-model="conditions.invoice_code"
                  >
                </div>
                <div class="col-sm-2">
                  <label class="form-label">Status</label>
                  <select 
                    class="form-select text-capitalize" 
                    style="padding-left: 0.5rem;padding-right: 0.6rem;"
                    v-model="conditions.status"
                  >
                    <option value="0">All</option>
                    <template v-for="(item, index) in statusOptions" :key="index">
                      <option :value="item.id">{{ item.name }}</option>
                    </template>
                  </select>
                </div>
                <div class="col-sm-4">
                  <label for="" class="form-label">Supplier Name</label>
                  <VueMultiselect 
                    v-model="supplierSelected" 
                    :options="stateData.list_suppliers" 
                    placeholder="Please choose supplier" 
                    label="partner_name" 
                    :show-labels="false"
                    :multiple="true" 
                    :close-on-select="false"
                    track-by="id"
                  />
                </div>
                <div class="col-sm-3">
                  <label class="form-label">Supplier Invoice Code</label>
                  <input type="text" 
                    class="form-control" 
                    placeholder="INV_001, INV_002,..."
                    v-model="supplier_inv_code_str"
                  >
                </div>
                <div class="col-sm-3">
                  <label class="form-label">Category Product Cost</label>
                  <select class="form-select" 
                    v-model="conditions.category_cost"
                  >
                    <option value="0">All</option>
                    <template v-for="(item, index) in categoryOptions" :key="index">
                      <option :value="item.id">
                        {{ item.category_name }}
                      </option>
                    </template>
                  </select>
                </div>
                <div class="col-sm-2 text-end">
                  <button class="btn btn-outline-primary w-75" 
                    style="margin-top: 1.8rem;"
                    @click="handleSearch"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
					</div>
				</div>
			</div>
		</div>
    <div class="row">
			<!-- Product Cost List -->
			<div class="col-md-12">
				<div class="card">
					<div class="card-body" v-if="hadSearched">
            <div class="col-md-12 row mb-1">
              <div class="col-md-6 alert alert-warning text-center">
                <span class="fw-bold me-2">TOTAL REMAINING:</span>
                <span class="fw-bold me-2">VND</span>
                <span class="fw-bold">{{ formatCurrency(stateData.total_lists_amount.total_remaining) }}</span>
              </div>
              <div class="col-md-6 alert alert-success text-center">
                <span class="fw-bold me-2">TOTAL PAID:</span>
                <span class="fw-bold me-2">VND</span>
                <span class="fw-bold">{{ formatCurrency(stateData.total_lists_amount.total_paid) }}</span>
              </div>
            </div>
            <div class="col-md-12 row mb-3">
              <div class="col-md-2 text-center">
                <span class="badge bg-label-info">
                  {{ statusOptions[0].name }}
                </span>
                <div class="mt-2">
                  <span class="me-2 text-info">VND</span>
									<span class="text-info">{{ formatCurrency(stateData.total_lists_amount.total_unpaid) }}</span>
								</div>
              </div>
              <div class="col-md-3 text-center">
                <span class="badge bg-label-warning">
                  {{ statusOptions[1].name }}
                </span>
                <div class="mt-2">
									<span class="me-2 text-warning">VND</span>
									<span class="text-warning">{{ formatCurrency(stateData.total_lists_amount.total_payment_due_soon) }}</span>
								</div>
              </div>
              <div class="col-md-3 text-center">
                <span class="badge bg-label-danger">
                  {{ statusOptions[2].name }}
                </span>
                <div class="mt-2">
									<span class="me-2 text-danger">VND</span>
									<span class="text-danger">{{ formatCurrency(stateData.total_lists_amount.total_overdue_payment) }}</span>
								</div>
              </div>
              <div class="col-md-2 text-center">
                <span class="badge bg-label-success">
                  {{ statusOptions[3].name }}
                </span>
                <div class="mt-2">
									<span class="me-2 text-success">VND</span>
									<span class="text-success">{{ formatCurrency(stateData.total_lists_amount.total_paid_on_time) }}</span>
								</div>
              </div>
              <div class="col-md-2 text-center">
                <span class="badge bg-label-primary">
                  {{ statusOptions[4].name }}
                </span>
                <div class="mt-2">
									<span class="me-2 text-primary">VND</span>
									<span class="text-primary">{{ formatCurrency(stateData.total_lists_amount.total_paid_late) }}</span>
								</div>
              </div>
            </div> 
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="p-1">Contract</th>
                  <th class="p-1">Category</th>
                  <th class="text-start p-1">Partner Name</th>
                  <th class="text-center p-1">Cost Amount</th>
                  <th class="text-center p-1">Due Date</th>
                  <th class="text-center p-1">Status</th>
                  <th class="text-center p-1">Actions</th>
                </tr>
              </thead>
              <tbody class="table-border-bottom-0">
                <tr v-for="(item, index) in stateData.listItems" :key="index">
                  <td class="width-20-percent p-2">{{ item.contract_code }}</td>
                  <td class="width-20-percent p-2">{{ getCategoryName(item.category_cost) }}</td>
                  <td class="width-20-percent p-2">
                    <div>
                      <span v-tooltip="item.partner_name">
                        <strong>{{ item.partner_short_name ? item.partner_short_name : item.partner_name }}</strong>
                      </span>
                    </div>
                  </td>
                  <td class="width-20-percent text-end p-2">
                    {{ (item.cost_type === 3 ? item.buy_currency : item.sell_currency) || '' }} 
                    {{ formatCurrency(item.cost_amount) }}
                  </td>
                  <td class="width-15-percent text-center p-2">{{ formatDate(item.payment_due_date) }}</td>
                  <td class="text-center p-2">
                    <span class="badge bg-label-info" v-if="item.status == 1">
                      {{ statusOptions[0].name}}
                    </span>
                    <span class="badge bg-label-warning" v-if="item.status == 2">
                      {{ statusOptions[1].name}}
                    </span>
                    <span class="badge bg-label-danger" v-if="item.status == 3">
                      {{ statusOptions[2].name}}
                    </span>
                    <span class="badge bg-label-success" v-if="item.status == 4">
                      {{ statusOptions[3].name}}
                    </span>
                    <span class="badge bg-label-primary" v-if="item.status == 5">
                      {{ statusOptions[4].name}}
                    </span>
                  </td>
                  <td class="p-1">
                    <div class="d-flex align-items-center" v-if="item.cost_type == 3">
                      <a href="#"
                        class="text-body me-3"
                        data-bs-toggle="modal"
                        data-bs-target="#viewProductCost"
                        @click="showProductCostReceivingViewModal(item.receiving_voucher_id)"
                      >
                        <i class="bx bx-show mx-1"></i>
                      </a>
                      <a href="#"
                        class="text-body me-3"
                        data-bs-toggle="modal"
                        data-bs-target="#addProductCost"
                        @click="showProductCostReceivingAddModal(item.receiving_voucher_id)"
                      >
                        <i class="bx bx-edit-alt"></i>
                      </a>
                      <a class="text-body icon-delete" @click="deleteProductCost(item.id)">
                        <i class='bx bx-x-circle'></i>
                      </a>
                    </div>
                    <div class="d-flex align-items-center" v-if="item.cost_type == 4">
                      <a href="#"
                        class="text-body me-3"
                        data-bs-toggle="modal"
                        data-bs-target="#viewProductCostDelivery"
                        @click="showProductCostDeliveryViewModal(item.delivery_voucher_id)"
                      >
                        <i class="bx bx-show mx-1"></i>
                      </a>
                      <a href="#"
                        class="text-body me-3"
                        data-bs-toggle="modal"
                        data-bs-target="#addProductCostDelivery"
                        @click="showProductCostDeliveryAddModal(item.delivery_voucher_id)"
                      >
                        <i class="bx bx-edit-alt"></i>
                      </a>
                      <a class="text-body icon-delete" @click="deleteProductCost(item.id)">
                        <i class='bx bx-x-circle'></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <br/>
            <div class="row mx-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">
                </div>
              </div>
              <div class="col-sm-12 text-center">
                <button type="button" 
                  class="btn rounded-pill btn-outline-primary" 
                  v-if="isShowButtonLoadMore"
                  @click="handleShowMoreItems"
                >
                  <span class="spinner-border text-white me-2" v-if="isLoadMore"></span>
                  Load more items...
                </button>
              </div>
            </div>
					</div>
				</div>
			</div>
    </div>

    <!-- Loading Modal -->
    <div class="modal modal-transparent show fade" v-if="isLoading" id="basicModal" style="display: block;">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <rise-loader :color="color" :size="size" style="text-align:center;"></rise-loader>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Displaying Product Cost-->
    <product-cost-receiving-add-modal
      :receiving_voucher_id="productCostReceivingIdAdd"
    /> 
    <product-cost-receiving-view-modal
      :receiving_voucher_id="productCostReceivingIdView"
    /> 

    <product-cost-delivery-add-modal
      :delivery_voucher_id="productCostDeliveryIdAdd"
      @closeProductCostDeliveryAddModal="handleCloseProductCostDeliveryAddModal"
    /> 
    <product-cost-delivery-view-modal
      :delivery_voucher_id="productCostDeliveryIdView"
    /> 
    <!-- /Modal Displaying Product Cost-->
  </div>
  <!-- / Content -->
</template>

<script>
import { mapState } from "vuex";
import RiseLoader from 'vue-spinner/src/RiseLoader.vue'
import flatPickr from 'vue-flatpickr-component';
import { configs } from '@/config/calendar.js';
import VueMultiselect from 'vue-multiselect'
import { CATEGORY_PRODUCT_COST, COST_STATUS } from "../../config/common.js"
import { errorAlert } from "../../helper/error.js"
import { utilities } from "../../services/utilities.js";
import useValidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import showConfirmDeleteAlert from "../../helper/error.js"
import {deletedAlert} from "../../helper/error.js"
import ProductCostDeliveryViewModal from "../invoice/ProductCostDeliveryViewModal";
import ProductCostDeliveryAddModal from "../invoice/ProductCostDeliveryAddModal";
import ProductCostReceivingViewModal from "../invoice/ProductCostReceivingViewModal";
import ProductCostReceivingAddModal from "../invoice/ProductCostReceivingAddModal";
import _ from 'lodash';


export default {
	name: 'ProductCostList',
  components: {
    RiseLoader,
    flatPickr,
    VueMultiselect,
    ProductCostDeliveryViewModal,
    ProductCostDeliveryAddModal,
    ProductCostReceivingViewModal,
    ProductCostReceivingAddModal
  },
	data() {
    return {
      page: 1,
      color: '#696cff',
      size: '20px',
      isLoading: false,
      today: new Date(),
      calendarConfig: configs,
      supplierSelected: null,
      supplier_inv_code_str: "",
      hadSearched: false,
      error_date: false,
      conditions: {
        start_date: "",
        end_date: "",
        contract_code: "",
        receiving_delivery_code: "",
        category_cost: 0,
        partner_id: [],
        supplier_invoice_code: [],
        status: 0
      },
      v$: useValidate(),
      productCostDetail: {},
      isShowButtonLoadMore: false,
      isLoadMore: false,
      productCostReceivingIdAdd: null,
      productCostReceivingIdView: null,
      productCostDeliveryIdAdd: null,
      productCostDeliveryIdView: null
		}
	},
  computed: {
    ...mapState({
      stateData: state => state.productCostList.stateData,
      totalItems: state => state.productCostList.stateData.totalItems,
      stateDataCostDeliveryAddModal: state => state.productCostDelivery.stateData
    }),
    categoryOptions() {
      return CATEGORY_PRODUCT_COST;
    },
    statusOptions() {
      return COST_STATUS;
    }
  },
  watch: {
    "supplierSelected" (newVal) {
      if (newVal == null) return;

      this.conditions.partner_id.length = 0;
      newVal.forEach(item => {
        this.conditions.partner_id.push(item.id);
      });
    },
    "supplier_inv_code_str" () {
      this.conditions.supplier_invoice_code.length = 0;
    }
  },
  beforeCreate() {
  },
  created() {
    this.conditions.start_date = this.$moment(this.today).startOf('month').format('YYYY-MM-DD');
    this.conditions.end_date = this.$moment(this.today).endOf('month').format('YYYY-MM-DD');
    // Get list supplier
    this.$store.dispatch('productCostList/getListPartner').then(
      (response) => { 
        this.stateData.list_suppliers = response.listItems;
      },
      (error) => {
        console.log(error);
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Can not get the supplier value !'
        });
      }
    );
  },
  methods: {
    handleSearch() {
      if (!this.checkConditionDate()) {
        this.error_date = true;
        return;
      }
      else {
        this.error_date = false;
      }

      if (this.supplier_inv_code_str) {
        this.conditions.supplier_invoice_code.length = 0;

        this.supplier_inv_code_str.split(",").forEach(item => {
          this.conditions.supplier_invoice_code.push(item.trim());
        });
      }

      this.page = 1;
      this.conditions["page"] = this.page;
      this.isSearch = true;
      this.hadSearched = true;
      this.isLoading = true;
      
      this.stateData.listItems.length = 0;
      
      this.$store.dispatch('productCostList/searchProductCost', this.conditions).then(
        (response) => {
          this.isLoading = false;
          this.stateData.currentPage = response.currentPage;
          this.stateData.totalItems = response.totalItems;
          this.stateData.totalPages = response.totalPages;
          this.stateData.total_lists_amount = response.total_lists_amount;
          if (response.listItems.length > 0) {
            // Estimate showing load more button
            if (this.stateData.totalPages > this.stateData.currentPage) {
              this.isShowButtonLoadMore = true;
              this.isLoadMore = false;
            }
            else {
              this.isShowButtonLoadMore = false;
              this.isLoadMore = false;
            }

            if (this.conditions.status != 0){
              response.listItems.forEach((item) => {
                let status_id = item.status;                  
                if (parseInt(this.conditions.status) == (parseInt(status_id))) {
                  item.status = status_id;
                  this.stateData.listItems.push(item);
                }
              });
            }
            else {
              this.stateData.listItems = response.listItems; 
            }
          }
          else {
            this.isShowButtonLoadMore = false;
            this.stateData.listItems = response.listItems; 
          }
        },
        error => {
          console.log(error);
          this.isLoading = false;
          errorAlert("error", "Network Error",'Can not get search data!');
        }
      );
    },
    handleShowMoreItems() {
      this.isLoadMore = true;
      this.page += 1;
      this.conditions["page"] = this.page;

      this.$store.dispatch('productCostList/searchProductCost', this.conditions).then(
        (response) => {
          this.isLoading = false;
          this.stateData.currentPage = response.currentPage;
          this.stateData.totalItems = response.totalItems;
          this.stateData.totalPages = response.totalPages;
          if (response.listItems.length > 0) {
            // Estimate showing load more button
            if (this.stateData.totalPages > this.stateData.currentPage) {
              this.isShowButtonLoadMore = true;
              this.isLoadMore = false;
            }
            else {
              this.isShowButtonLoadMore = false;
              this.isLoadMore = false;
            }

            if (this.conditions.status != 0){
              response.listItems.forEach((item) => {
                let status_id = item.status;                  
                if (parseInt(this.conditions.status) == (parseInt(status_id))) {
                  item.status = status_id;
                  this.stateData.listItems.push(item);
                }
              });
            }
            else {
              response.listItems.forEach((item) => {
                this.stateData.listItems.push(item);
              });
            }
          }
          else {
            this.stateData.listItems = response.listItems; 
          }
        },
        error => {
          console.log(error);
          this.isLoading = false;
          errorAlert("error", "Network Error",'Can not get search data!');
        }
      );
    },
    getCategoryName(category_code_id) {
      if (category_code_id) {
        return this.categoryOptions.filter(item => item.id == category_code_id)[0].category_name;
      }
    },
    countRemainingDays(payment_due_date) {
      if (!payment_due_date) return 0;
      let due_date = this.$moment(payment_due_date.toString());
      return due_date.diff(this.today, 'days');
    },
    getNotifyMessage (value){
      let remaining_days = this.countRemainingDays(this.productCostDetail.payment_due_date);
      let str = remaining_days == 1 ? " day" : " days";
      let result = "";
      switch (value) {
        case 1:
        case 2:
          result = "Remaining Payment Time: " + remaining_days + str;
          break;
        case 3: 
          result = "Late Payment for " + Math.abs(remaining_days) + str;
          break;
        case 4: 
          result = "Payment has already paid";
          break;
        case 5:
          result = "Already paid, but late for " + Math.abs(remaining_days) + str;
          break;
        default:
          break;
      }
      return result;
    },
    formatDate(date) {
      if (date) {
        return utilities.changeFormatDate(date);
      }
    },
    formatCurrency(amount) {
      return utilities.getFormatCurrency(amount);
    },
    checkConditionDate() {
      let startDate = this.$moment(this.conditions.start_date.toString());
      let endDate = this.$moment(this.conditions.end_date.toString());
      return startDate.diff(endDate, 'days') <= 0;
    },
    deleteProductCost(product_cost_id) {
      showConfirmDeleteAlert()
      .then(
        (result) => {
          if(!result) return;

          this.$store.dispatch('productCostList/deleteProductCost', product_cost_id).then(
            () => { 
              this.isLoading = false;
              deletedAlert();
              // Remove item from list
              this.stateData.listItems = this.stateData.listItems.filter(item => item.id != product_cost_id);
            },
            (error) => {
              this.isLoading = false;
              // this.showPaging = true;
              let resp = error.response;
              if (resp.status == 406){
                errorAlert("error", "Delete Not Allowed", resp.data.detail);
              }
              else {
                errorAlert("error", "Network Error", "Failed to deleted Product Cost data!");
              }
              
            }
          );
        }
      )
    },
    handleShowDetail(product_cost_id) {
      this.isLoading = true;
      this.$store.dispatch('productCostList/getFxiedCostInfo', product_cost_id).then(
        (response) => { 
          this.isLoading = false;
          this.productCostDetail = response;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.productCostDetail = {};
          errorAlert("error","Network Error",'Can not get Product Cost information !');
        }
      );
    },
    getTaxAmount () {
      if (this.productCostDetail.cost_tax && this.productCostDetail.cost_amount) {
        return this.productCostDetail.cost_amount * this.productCostDetail.cost_tax / 100;
      }
    },
    getCostAmount () {
      if (this.productCostDetail.cost_tax && this.productCostDetail.cost_amount) {
        let tax = this.getTaxAmount();
        return this.productCostDetail.cost_amount + tax;
      }
    },
    getTaxActualAmount () {
      if (this.productCostDetail.cost_tax && this.productCostDetail.cost_actual_amount) {
        return this.productCostDetail.cost_actual_amount * this.productCostDetail.cost_tax / 100;
      }
    },
    getCostActualAmount () {
      if (this.productCostDetail.cost_tax && this.productCostDetail.cost_actual_amount) {
        let tax = this.getTaxActualAmount();
        return this.productCostDetail.cost_actual_amount + tax;
      }
    },
    showProductCostReceivingViewModal(receiving_id) {
      this.productCostReceivingIdView = receiving_id;
    },
    showProductCostReceivingAddModal(receiving_id) {
      this.productCostReceivingIdAdd = receiving_id;
    },
    showProductCostDeliveryViewModal(delivery_id) {
      this.productCostDeliveryIdView = delivery_id;
    },
    showProductCostDeliveryAddModal(delivery_id) {
      this.productCostDeliveryIdAdd = delivery_id;
    },
    // handleCloseProductCostReceivingAddModal(value) {
    //   console.log("handleCloseProductCostReceivingAddModal productCostReceivingIdAdd: ", this.productCostReceivingIdAdd);
    //   console.log("handleCloseProductCostReceivingAddModal value: ", value);
    // },
    // handleCloseProductCostReceivingViewModal(value) {
    //   console.log("handleCloseProductCostReceivingViewModal productCostReceivingIdView: ", this.productCostReceivingIdView);
    //   console.log("handleCloseProductCostReceivingViewModal value: ", value);
    // },
    handleCloseProductCostDeliveryAddModal(value) {
      console.log("handleCloseProductCostDeliveryAddModal productCostDeliveryIdAdd: ", this.productCostDeliveryIdAdd);
      console.log("handleCloseProductCostDeliveryAddModal value: ", value);
      let delivery_id = _.cloneDeep(this.productCostDeliveryIdAdd);
      // this.productCostDeliveryIdAdd = value ? null : value;
      // update listittem with new data
      this.stateData.listItems = this.stateData.listItems.map(item => {
        if (item.delivery_voucher_id == delivery_id) {
          item.cost_amount = this.stateDataCostDeliveryAddModal.cost_amount;
          item.payment_due_date = this.stateDataCostDeliveryAddModal.payment_due_date;
          item.status = this.stateDataCostDeliveryAddModal.status;
          let new_partner = this.stateData.list_suppliers.find(supplier => supplier.id == this.stateDataCostDeliveryAddModal.partner_id);
          if (new_partner) {
            item.partner_name = new_partner.partner_name;
          }
        }
        return item;
      });
      this.productCostDeliveryIdView = 0;
    },
    // handleCloseProductCostDeliveryViewModal(value) {
    //   console.log("handleCloseProductCostDeliveryViewModal productCostDeliveryIdView: ", this.productCostDeliveryIdView);
    //   console.log("handleCloseProductCostDeliveryViewModal value: ", value);
    // }

  },
  validations() {
    return {
      conditions: {
        start_date: {
          required: helpers.withMessage('START DATE is required', required)
        },
        end_date: {
          required: helpers.withMessage('END DATE is required', required)
        }
      }
    }
  }
}
</script>

<style scoped>
  .btn-add-fcost {
    float: right;
    margin-top: -6px;
  }
  .text-white {
    color: white;
  }
</style>